import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let cadena = '';
    let mes = super.transform(value, 'L');
    let complemento='d y h:mm a';
    switch (mes) {
      case '1':
        cadena = 'Ene ' + super.transform(value, complemento);
        break;
      case '2':
        cadena = 'Feb ' + super.transform(value, complemento);
        break;
      case '3':
        cadena = 'Mar ' + super.transform(value, complemento);
        break;
      case '4':
        cadena = 'Abr ' + super.transform(value, complemento);
        break;
      case '5':
        cadena = 'May ' + super.transform(value, complemento);
        break;
      case '6':
        cadena = 'Jun ' + super.transform(value, complemento);
        break;
      case '7':
        cadena = 'Jul ' + super.transform(value, complemento);
        break;
      case '8':
        cadena = 'Ago ' + super.transform(value, complemento);
        break;
      case '9':
        cadena = 'Sep ' + super.transform(value, complemento);
        break;
      case '10':
        cadena = 'Oct ' + super.transform(value, complemento);
        break;
      case '11':
        cadena = 'Nov ' + super.transform(value, complemento);
        break;
      case '12':
        cadena = 'Dic ' + super.transform(value, complemento);
        break;
    }

    return cadena; //super.transform(value, "EEEE d MMMM y h:mm a");
  }
}
